import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';

import { SingleDatePickerComponent } from './single-date-picker.component';
import { isDateItemSelectedPipe } from 'Angular/features/components/date-controls/single-date-picker/pipes/is-date-item-selected.pipe';
import { isDateItemWithinDateRangePipe } from 'Angular/features/components/date-controls/single-date-picker/pipes/is-date-item-within-date-range.pipe';
import { isValidDateForDateRangePipe } from 'Angular/features/components/date-controls/single-date-picker/pipes/is-valid-date-for-date-range.pipe';

@NgModule({
    declarations: [
        isDateItemSelectedPipe,
        isDateItemWithinDateRangePipe,
        isValidDateForDateRangePipe,
        SingleDatePickerComponent,
    ],
    exports: [SingleDatePickerComponent],
    imports: [AppendToBodyModule, CommonModule, DisabledModule, FormsModule, SingleSelectDropdownModule],
})
export class SingleDatePickerModule {}
